'use strict';

function MobileMenu() {
  // Inject the mobile menu button
  $('.region-header').prepend('<button aria-label="Open Menu"  aria-expanded="false" title="Open menu" id="block-mobile-menu-button" ><span>Open menu</span></button>'); // Inject the mobile menu container
  $('body').append('<div id="block-mobile-menu-overlay"></div>'); // Bind the click action to open close menu
  $('#block-mobile-menu-button, #block-mobile-menu-overlay').click(function ($event) {
    $event.preventDefault();
    $('#block-mobile-menu-button').toggleClass('active');
    $('#block-mobile-menu').toggleClass('active');
    $('#block-mobile-menu-overlay').toggleClass('active');
    $('#block-mobile-menu-button').hasClass('active') ? $('#block-mobile-menu-button').attr('aria-expanded', 'true') : $('#block-mobile-menu-button').attr('aria-expanded', 'false');
  }); // On the mobile menu the active link show all the parents and immediate child

  $('#block-mobile-menu a.is-active').parents('ul').addClass('show');
  $('#block-mobile-menu a.is-active').parents('.level-1').addClass('show');
  $('#block-mobile-menu a.is-active').parents('ul').siblings('.expand').addClass('active');
  $('#block-mobile-menu a.is-active').siblings('ul').addClass('show');
  $('#block-mobile-menu a.is-active').siblings('.level-1').addClass('show');
  $('#block-mobile-menu a.is-active').siblings('.expand').addClass('active'); // Add a close button to close the slide out menu

  $('#block-mobile-menu').prepend('<a href="#" class="close-mobile-menu" aria-label="Close menu" alt="close menu"><i class="icon-close"></i></a>'); // Bind the close menu action

  $('.close-mobile-menu').click(function ($event) {
    $event.preventDefault();
    $('#block-mobile-menu-button').toggleClass('active');
    $('#block-mobile-menu').toggleClass('active');
    $('#block-mobile-menu-overlay').toggleClass('active');
  });
};
export default MobileMenu;
